import { useState, useEffect } from 'react';

/**
 * 監測線上/離線狀態的 Hook
 * @returns {boolean} isOnline - 當前是否在線
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(() => {
    // 初始狀態：檢查 navigator.onLine
    if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
      return navigator.onLine;
    }
    return true; // 預設為在線
  });

  useEffect(() => {
    // 處理上線事件
    const handleOnline = () => {
      console.log('🌐 網路已連線');
      setIsOnline(true);
    };

    // 處理離線事件
    const handleOffline = () => {
      console.log('🔌 網路已斷線');
      setIsOnline(false);
    };

    // 註冊事件監聽器
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // 清理函數
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}

/**
 * 進階版：包含重連偵測的 Hook
 * @returns {Object} { isOnline, wasOffline }
 */
export function useOnlineStatusWithHistory() {
  const [isOnline, setIsOnline] = useState(() => {
    if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
      return navigator.onLine;
    }
    return true;
  });

  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      console.log('🌐 網路已恢復');
      setIsOnline(true);
      setWasOffline(true);

      // 3 秒後重置 wasOffline 狀態
      setTimeout(() => {
        setWasOffline(false);
      }, 3000);
    };

    const handleOffline = () => {
      console.log('🔌 網路已中斷');
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline, wasOffline };
}